import Icon from '../components/Icon.vue'

Icon.register({
  percent: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M112 224C173.9 224 224 173.9 224 112S173.9 0 112 0 0 50.1 0 112 50.1 224 112 224zM112 64C138.5 64 160 85.5 160 112S138.5 160 112 160 64 138.5 64 112 85.5 64 112 64zM336 288C274.1 288 224 338.1 224 400S274.1 512 336 512 448 461.9 448 400 397.9 288 336 288zM336 448C309.5 448 288 426.5 288 400S309.5 352 336 352 384 373.5 384 400 362.5 448 336 448zM392.3 0.2L423.9 0.1C443.3 0 454.8 21.9 443.6 37.9L77.4 501.6A23.9-23.9 0 0 0 57.8 511.8L24.4 511.9C4.9 511.9-6.5 490 4.7 474.1L372.7 10.4C377.2 4 384.5 0.2 392.3 0.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/percent.js
// module id = C9DG
// module chunks = 144